import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { DatasetState } from "../../../types/types";
import { inferSchema } from "./dashboardUpload.utils";

export function makeSampleSurvey(): DatasetState {
  const regions = [
    { region: "North", city: "Pristina", lat: 42.6629, lng: 21.1655 },
    { region: "South", city: "Prizren", lat: 42.2139, lng: 20.7397 },
    { region: "East", city: "Gjilan", lat: 42.4637, lng: 21.4691 },
    { region: "West", city: "Peja", lat: 42.659, lng: 20.2883 },
  ];

  const start = dayjs().subtract(59, "day");
  const rows: any[] = [];

  for (let i = 0; i < 60; i++) {
    const d = start.add(i, "day");
    const loc = regions[i % regions.length];

    let base =
      60 + 10 * Math.sin((2 * Math.PI * i) / 7) + (Math.random() - 0.5) * 10;

    if (i === 15) base += 25;
    if (i === 37) base -= 20;

    const score = Math.max(0, Math.min(100, Math.round(base * 10) / 10));

    rows.push({
      response_id: 1000 + i,
      date: d.format("YYYY-MM-DD"),
      region: loc.region,
      city: loc.city,
      lat: loc.lat,
      lng: loc.lng,
      score,
      progress_units: Math.floor(Math.random() * 11),
      sentiment: ["Positive", "Neutral", "Negative"][
        Math.floor(Math.random() * 100) % 3
      ],
      category: ["Service", "Price", "Quality", "UX", "Support"][
        Math.floor(Math.random() * 100) % 5
      ],
      value: Math.floor(Math.random() * 500) + 1,
      notes: [
        "All good",
        "Minor issue",
        "Waiting for reply",
        "Great experience",
        "Could be faster",
      ][Math.floor(Math.random() * 100) % 5],
    });
  }

  return {
    fileName: "sample_survey.xlsx",
    schema: inferSchema(rows),
    rowsSample: rows.slice(0, 200),
  };
}

export function downloadSampleSurvey() {
  const ds = makeSampleSurvey();
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(ds.rowsSample);
  XLSX.utils.book_append_sheet(wb, ws, "responses");
  XLSX.writeFile(wb, "sample_survey.xlsx");
}
